
import React from 'react';
import Header from '@/components/Header';
import Footer from '@/components/Footer';
import BusinessOnboardingSteps from '@/components/onboarding/BusinessOnboardingSteps';
import BusinessOnboardingContent from '@/components/onboarding/BusinessOnboardingContent';
import { useBusinessOnboarding } from '@/hooks/useBusinessOnboarding';

const BusinessOnboarding = () => {
  const {
    isLoading,
    currentStep,
    setupComplete,
    signupData,
    onboardingData,
    referralForm,
    handleBusinessSetup,
    handleBackStep,
    handleContinueToDashboard
  } = useBusinessOnboarding();

  return (
    <div className="min-h-screen flex flex-col">
      <Header isLoggedIn={false} />
      
      <main className="flex-grow py-10 px-4 bg-gray-50">
        <div className="container mx-auto max-w-4xl">
          <div className="text-center mb-6">
            <h1 className="text-3xl font-bold text-primary">Set Up Your Referral Program</h1>
            <p className="text-gray-600 mt-2">
              Complete the following steps to set up your referral program.
            </p>
          </div>
          
          <BusinessOnboardingSteps currentStep={currentStep} />
          
          <BusinessOnboardingContent
            currentStep={currentStep}
            setupComplete={setupComplete}
            referralForm={referralForm}
            signupData={signupData}
            isLoading={isLoading}
            onboardingData={onboardingData}
            onSubmit={handleBusinessSetup}
            onBackStep={handleBackStep}
            onContinue={handleContinueToDashboard}
          />
        </div>
      </main>
      
      <Footer />
    </div>
  );
};

export default BusinessOnboarding;
